import {useEffect} from 'react';
import {useRedirection} from '@app/modules/redirection/hooks';
import {useRouter} from 'next/router';
import {useAutolog} from '@app/hooks/auth/useAutolog';
import {AuthStatus} from '@app/hooks/auth/useAutolog/utils';
import {useRecTokenQuery} from '@app/graphql/generated';
import {setRECToken} from '@app/modules/tracking/logCenter';

/**
 * Controls the behavior and variables of the missinginfo page
 * Is synced to user auth state to be able to bypass screens etc
 * @returns
 */
export const useMissingInfoController = () => {
	const {data, status} = useAutolog();
	const redirect = useRedirection();
	const {push} = useRouter();

	// Token will not be provided in useUserData so we need to use this as a backup
	useRecTokenQuery({
		onCompleted: (data) => {
			data.me?.recToken?.token && setRECToken(data.me?.recToken?.token);
		},
	});

	/**
	 *  redirect to config.deezerWebsiteUrl/login if user isn't connected and the user
	 *  has already completed his information.
	 *  @todo: update redirection to /login when we will be able to use /login as deezer auth
	 */
	useEffect(() => {
		// User has finalised its account and is connected -> redirection to deezer
		if (status === AuthStatus.logged) {
			return redirect();
		} else if (status === AuthStatus.unlogged) {
			push('/login');
		}
	}, [redirect, push, status]);

	return {
		isLoading: status === AuthStatus.loading,
		missingInfos: status === AuthStatus.missinginfo ? data.required_info : [],
	};
};
